import { useHead } from "@unhead/react";
import { useParams } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { PublicFooter } from "@/components/nav/PublicFooter";
import { PublicNav } from "@/components/nav/PublicNav";
import { BrandsV2 } from "@/components/pieces/marketing/BrandsV2";
import { PartnerTestimonials } from "@/components/pieces/marketing/PartnerTestimonials";
import { SITE_NAME } from "@/css/constants";

import { MainHero } from "./MainHero";

const PAGE_VARIANTS = {
  default: {
    heading: "A Better Way to Train",
    subheading:
      "Too often training fails to stick. Exec offers a better way to prepare employees for company-defining conversations.",
    formTitle: "Book Demo",
    formId: "nrJWnDcGiSus",
  },
  thesignal: {
    heading: "The Signal Readers Exclusive Free Offer",
    subheading:
      "Signal readers get 3 free Roleplay licenses with unlimited AI practice sessions, plus priority access to Call Scoring beta with free credits. Transform how your team prepares for critical sales conversations.",
    formTitle: "3 Free Roleplay Licenses + Call Scoring",
    formId: "2Chxgy5M53us",
  },
};

export function Demo() {
  let { slug } = useParams();
  useHead({
    bodyAttrs: { class: "public-site" },
  });

  if (!slug || !(slug in PAGE_VARIANTS)) {
    slug = "default";
  }
  const { heading, subheading, formTitle, formId } =
    PAGE_VARIANTS[slug as keyof typeof PAGE_VARIANTS];

  return (
    <>
      <SEOHead
        title={`Book a Demo - ${SITE_NAME}`}
        description="Experience what Exec can do for your team. Schedule a demo today."
        canonicalPath="/about-us"
        image="https://placement-pub.s3.us-east-2.amazonaws.com/about-meta.jpg"
      />
      <PublicNav />
      <MainHero
        heading={heading}
        subheading={subheading}
        formTitle={formTitle}
        formId={formId}
      />
      <BrandsV2 opacity={1} backgroundColor="#FFF" />
      <PartnerTestimonials
        partnerIds={[
          "phm",
          "axonius",
          "xencor",
          "eko",
          "cockroach",
          "resultscx",
        ]}
        tint="teal"
      />
      <PublicFooter />
    </>
  );
}
